<template>
  <div class="autoform">
    <div class="field" v-for="item in formData">
        <template v-if="item.type === 'input'">
            <p>
                {{item.title}}：
                <span v-show="item.required==1">*</span>
            </p>
            <input type="text" :placeholder="item.hint" v-model="form[item.name]" />
        </template>
        <template v-if="item.type === 'select'">
            <p>
                {{item.title}}：
                <span v-show="item.required==1">*</span>
            </p>
            <select name="" v-model="form[item.name]" id="">
                <option :value="child" v-for="child in item.options">
                    {{child}}
                </option>
            </select>
        </template>
        <template v-if="item.type === 'radio'">
            <p>
                {{item.title}}：
                <span v-show="item.required==1">*</span>
            </p>
            <div class="radio">
                <label :for="item.name+index" v-for="(child,index) in item.options">
                    <input type="radio" :name="item.name" v-model="form[item.name]" :value="child" :id="item.name+index"> 
                    <span>{{child}}</span>
                </label>
            </div>
        </template>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        formData:Array
    },
    data(){
        return{
            form:{}
        }
    },
    watch:{
        form:{
            handler:function(val){
                this.$emit('formChange',val)
            },
            deep:true
        }
    }
    
};
</script>

<style scoped>
.field {
  min-height: 60px;
  padding: 5px 0;
}

.field input[type="text"],
.field input[type="number"],
select {
  font-size: 1em;
  border: 1px solid #cfcfcf;
  width: 100%;
  line-height: 45px;
  padding: 5px 10px;
  border-radius: 7px;
  height: 45px;
  outline: none;
  color: #a3a3a3;
}

.field p {
  color: #666666;
  font-size: 0.9em;
  margin-bottom: 5px;
}

.field p > span {
  color: red;
}

.field > label {
  font-size: 0.8em;
  color: #b2b2b2;
}

.blue {
  color: #42adff;
}
.radio{
    display: flex;
    align-items: center;
    color: #666;
}
.radio label{
    margin-right: 20%;
}
.radio label span{
    margin-left: 10px;
}
</style>